import { caseManagementApi } from '../caseManagementApi';
import { CaseManageView } from '../types/caseManageTypes';
import { CaseManagementUpdateRequest } from '../requests/caseManagementUpdateRequest';

const caseEndpointsInjected = caseManagementApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get a case management record by ID
    // GET /CaseManagement?id=<id>
    getCaseManagement: builder.query<CaseManageView, { id: string }>({
      query: ({ id }) => ({
        url: 'CaseManagement',
        params: { id },
      }),
      providesTags: (result, error, { id }) => [{ type: 'CaseManagement', id }],
    }),

    // Update a case management record
    // POST /CaseManagement
    updateCaseManagement: builder.mutation<CaseManageView, CaseManagementUpdateRequest>({
      query: (updateRequest) => ({
        url: 'CaseManagement',
        method: 'POST',
        body: updateRequest,
      }),
      invalidatesTags: (result, error, { caseManageView }) => [
        { type: 'CaseManagement', id: caseManageView.id },
        'CaseManagement',
        // Invalidate all worklist queries to refresh sidebar counts
        'Worklist',
      ],
    }),
  }),
  overrideExisting: false,
});

// Export enhanced API for slice extraReducers
export const caseEndpoints = caseEndpointsInjected;

export const { useGetCaseManagementQuery, useUpdateCaseManagementMutation } = caseEndpointsInjected;
